import arrayLikeKeys from "./component-library321.mjs";
import baseKeys from "./component-library326.mjs";
import isArrayLike from "./component-library323.mjs";
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
export {
  keys as default
};
